function getUser() {
  try {
    return JSON.parse(window.localStorage.getItem('user') || 'null');
  } catch (err) {
    return null;
  }
}

export function nexusHeaders(extra = {}) {
  const user = getUser();
  let apiToken = '';
  try {
    apiToken = window.sessionStorage.getItem('teable_token') || '';
  } catch (err) {
    apiToken = '';
  }
  return {
    'Content-Type': 'application/json',
    ...(apiToken ? { 'x-api-token': apiToken } : {}),
    'x-nexus-user': user?.Name || user?.Username || '',
    'x-nexus-user-id': user?.id || user?.Id || user?.userId || user?.Email || user?.email || user?.Username || '',
    'x-nexus-team': user?.Team || '',
    'x-nexus-role': user?.role || '',
    'x-nexus-permissions': Array.isArray(user?.permissions) ? user.permissions.join(', ') : (user?.permissions || ''),
    'x-nexus-branches': user?.Branch || user?.branches || '',
    'x-nexus-account': user?.csrAccount || user?.Username || user?.username || '',
    'x-nexus-agent-alias': user?.agentAlias || '',
    'x-nexus-session-id': user?.sessionId || '',
    'x-nexus-monitoring-record-id': user?.monitoringRecordId || '',
    ...extra
  };
}

export async function requestJson(url, options = {}) {
  const startedAt = performance.now();
  const response = await fetch(url, {
    ...options,
    headers: nexusHeaders(options.headers || {})
  });
  const text = await response.text();
  const data = text ? JSON.parse(text) : {};
  if (!response.ok) {
    const error = new Error(data.error || data.message || `HTTP ${response.status} from ${url}`);
    error.status = response.status;
    error.data = data;
    throw error;
  }
  window.NexusPerf?.measure?.('react.api.request', performance.now() - startedAt, {
    url,
    method: options.method || 'GET'
  });
  return data;
}
